(() => {
  const PREFIX_RE = /^CRAMPONS POUR\s*/i;

  function patchCard(card) {
    // éviter double traitement
    if (card.__patched) return;

    const titleLink = card.querySelector('.card-title .collection-title');
    if (!titleLink) return;

    // privilégie data-title de la carte (ton HTML l’a)
    const raw = (card.getAttribute('data-title') || titleLink.textContent || '').trim();
    const hasPrefix = PREFIX_RE.test(raw);
    if (!hasPrefix) return;

    const rest = raw.replace(PREFIX_RE, '').trim();

    // reconstruit le contenu du lien : eyebrow + titre
    titleLink.innerHTML =
      '<span class="collection-eyebrow">CRAMPONS POUR</span>' +
      '<span class="collection-title-main">' + rest + '</span>';

    card.__patched = true;
  }

  function scan(root) {
    (root || document).querySelectorAll('.collection-list .card-item').forEach(patchCard);
  }

  // au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  // si le slider ajoute/remplace des slides
  const target = document.querySelector('.collection-list') || document.body;
  const mo = new MutationObserver(() => scan());
  mo.observe(target, { childList: true, subtree: true });
})();
